/**
 * Please note:
 *
 * Translations are provided as an illustration only and are
 * not guaranteed to be accurate or error-free.
 *
 * They are designed to show developers where to store their
 * chosen phrase or spelling variant in the target language.
 */

export const AG_CHARTS_LOCALE_KO_KR: Record<string, string> = {
    ariaAnnounceChart: '차트, ${seriesCount}[number] 시리즈',
    ariaAnnounceFlowProportionLink: '링크 ${index} / ${count}, ${from}에서 ${to}로, ${sizeName} ${size}',
    ariaAnnounceFlowProportionNode: '노드 ${index} / ${count}, ${description}',
    ariaAnnounceGaugeChart: '게이지 차트, ${caption}',
    ariaAnnounceHierarchyChart: '계층 차트, ${caption}',
    ariaAnnounceHierarchyDatum: '레벨 ${level}[number], ${count}[number] 자식, ${description}',
    ariaAnnounceHoverDatum: '${datum}',
    ariaDescriptionLegendItem: '스페이스바 또는 엔터를 눌러 표시 여부를 전환하세요',
    ariaLabelAddHorizontalLine: '수평선 추가',
    ariaLabelAnnotationOptionsToolbar: '주석 옵션',
    ariaLabelAnnotationSettingsDialog: '주석 설정',
    ariaLabelColorPicker: '색상 선택기',
    ariaLabelFinancialCharts: '금융 차트',
    ariaLabelLegend: '범례',
    ariaLabelLegendItem: '${label}, 범례 항목 ${index}[number] / ${count}[number]',
    ariaLabelLegendItemUnknown: '알 수 없는 범례 항목',
    ariaLabelLegendPageNext: '다음 범례 페이지',
    ariaLabelLegendPagePrevious: '이전 범례 페이지',
    ariaLabelLegendPagination: '범례 페이지 매김',
    ariaLabelNavigator: '네비게이터',
    ariaLabelNavigatorMaximum: '최대',
    ariaLabelNavigatorMinimum: '최소',
    ariaLabelNavigatorRange: '범위',
    ariaLabelRangesToolbar: '범위',
    ariaLabelSettingsTabBar: '설정',
    ariaLabelZoomToolbar: '확대',
    ariaValuePanRange: '${min}[percent0to2dp]에서 ${max}[percent0to2dp]까지',
    contextMenuDownload: '다운로드',
    contextMenuPanToCursor: '여기로 이동',
    contextMenuToggleOtherSeries: '다른 계열 전환',
    contextMenuToggleSeriesVisibility: '가시성 전환',
    contextMenuZoomToCursor: '여기로 확대',
    dialogHeaderChannel: '채널',
    dialogHeaderDatePriceRange: '날짜 및 가격',
    dialogHeaderDateRange: '날짜 범위',
    dialogHeaderFibonacciRange: '피보나치 되돌림',
    dialogHeaderLine: '라인',
    dialogHeaderPriceRange: '가격 범위',
    dialogHeaderText: '텍스트',
    dialogInputAlign: '정렬',
    dialogInputColorPicker: '색상',
    dialogInputColorPickerAltText: '텍스트 색상',
    dialogInputExtendAbove: '위로 확장',
    dialogInputExtendBelow: '아래로 확장하기',
    dialogInputExtendChannelEnd: '채널 끝 확장',
    dialogInputExtendChannelStart: '채널 시작 확장',
    dialogInputExtendLeft: '왼쪽으로 확장',
    dialogInputExtendLineEnd: '선 끝 연장',
    dialogInputExtendLineStart: '선 시작 확장',
    dialogInputExtendRight: '오른쪽 확장',
    dialogInputFibonacciBands: '밴드',
    dialogInputFibonacciBandsAltText: '피보나치 밴드',
    dialogInputFillColorPicker: '색 채우기',
    dialogInputFillColorPickerAltText: '채우기 색상',
    dialogInputFontSize: '크기',
    dialogInputFontSizeAltText: '글꼴 크기',
    dialogInputLineStyle: '대시',
    dialogInputPosition: '위치',
    dialogInputReverse: '"반전"',
    dialogInputShowFill: '채우기 표시',
    dialogInputStrokeWidth: '굵기',
    dialogInputStrokeWidthAltText: '선 굵기',
    iconAltTextAlignCenter: '가운데 맞춤',
    iconAltTextAlignLeft: '왼쪽',
    iconAltTextAlignRight: '오른쪽',
    iconAltTextClose: '닫기',
    iconAltTextLineStyleDashed: '긴 대시',
    iconAltTextLineStyleDotted: '‘짧은 대시’',
    iconAltTextLineStyleSolid: '실선',
    iconAltTextPositionBottom: '아래쪽',
    iconAltTextPositionCenter: '중앙',
    iconAltTextPositionTop: '위',
    inputTextareaPlaceholder: '텍스트 추가',
    measurerDateRangeBars: '${value}[number] 막대',
    measurerPriceRangePercent: '${value}[percent]',
    measurerPriceRangeValue: '${value}[number]',
    measurerVolume: '용량 ${value}',
    overlayLoadingData: '데이터를 로드하는 중...',
    overlayNoData: '표시할 데이터가 없습니다',
    overlayNoVisibleSeries: '보이는 시리즈가 없습니다',
    overlayUnsupportedBrowser: '호환되지 않는 브라우저 버전입니다. 브라우저를 업그레이드해 주십시오.',
    seriesHistogramTooltipCount: '${yName} (개수)',
    seriesHistogramTooltipFrequency: '빈도',
    seriesHistogramTooltipMean: '${yName} (평균)',
    seriesHistogramTooltipSum: '${yName} (합계)',
    toolbarAnnotationsArrow: '화살표',
    toolbarAnnotationsArrowDown: '아래쪽 화살표',
    toolbarAnnotationsArrowUp: '위쪽 화살표',
    toolbarAnnotationsCallout: '콜아웃',
    toolbarAnnotationsClearAll: '모두 지우기',
    toolbarAnnotationsComment: '댓글',
    toolbarAnnotationsDatePriceRange: '날짜 및 가격',
    toolbarAnnotationsDateRange: '날짜 범위',
    toolbarAnnotationsDelete: '삭제',
    toolbarAnnotationsDisjointChannel: '독립 채널',
    toolbarAnnotationsDragHandle: '도구 모음 끌기',
    toolbarAnnotationsFibonacciAnnotations: '피보나치',
    toolbarAnnotationsFibonacciRetracement: '피보나치 되돌림',
    toolbarAnnotationsFibonacciRetracementTrendBased: '피보나치 추세 기반',
    toolbarAnnotationsFillColor: '채우기 색상',
    toolbarAnnotationsHorizontalLine: '수평선',
    toolbarAnnotationsLineAnnotations: '추세선',
    toolbarAnnotationsLineColor: '선 색상',
    toolbarAnnotationsLineStrokeWidth: '선 획 너비',
    toolbarAnnotationsLineStyle: '선 스타일',
    toolbarAnnotationsLock: '잠금',
    toolbarAnnotationsMeasurerAnnotations: '측정기',
    toolbarAnnotationsNote: '노트',
    toolbarAnnotationsParallelChannel: '평행 채널',
    toolbarAnnotationsPriceRange: '가격 범위',
    toolbarAnnotationsQuickDatePriceRange: '측정',
    toolbarAnnotationsSettings: '설정',
    toolbarAnnotationsShapeAnnotations: '화살표',
    toolbarAnnotationsText: '텍스트',
    toolbarAnnotationsTextAnnotations: '텍스트 주석',
    toolbarAnnotationsTextColor: '텍스트 색상',
    toolbarAnnotationsTextSize: '텍스트 크기',
    toolbarAnnotationsTrendLine: '추세선',
    toolbarAnnotationsUnlock: '잠금 해제',
    toolbarAnnotationsVerticalLine: '세로 선',
    toolbarRange1Month: '1개월',
    toolbarRange1MonthAria: '1개월',
    toolbarRange1Year: '1년',
    toolbarRange1YearAria: '1년',
    toolbarRange3Months: '3개월',
    toolbarRange3MonthsAria: '3개월',
    toolbarRange6Months: '6개월',
    toolbarRange6MonthsAria: '6개월',
    toolbarRangeAll: '전체',
    toolbarRangeAllAria: '모두',
    toolbarRangeYearToDate: '연초부터 현재까지',
    toolbarRangeYearToDateAria: '올해 초부터 현재까지',
    toolbarSeriesTypeCandles: '캔들',
    toolbarSeriesTypeDropdown: '차트 유형',
    toolbarSeriesTypeHighLow: '고저',
    toolbarSeriesTypeHLC: 'HLC',
    toolbarSeriesTypeHollowCandles: '속빈 양초',
    toolbarSeriesTypeLine: '라인',
    toolbarSeriesTypeLineWithMarkers: '마커가 있는 선',
    toolbarSeriesTypeOHLC: 'OHLC',
    toolbarSeriesTypeStepLine: '계단형 선',
    toolbarZoomPanEnd: '끝으로 이동',
    toolbarZoomPanLeft: '왼쪽으로 이동',
    toolbarZoomPanRight: '오른쪽으로 이동',
    toolbarZoomPanStart: '시작 위치로 이동',
    toolbarZoomReset: '줌 리셋',
    toolbarZoomZoomIn: '확대',
    toolbarZoomZoomOut: '축소',
    tooltipPaginationStatus: '${index}[number] / ${count}[number]',
};
